import { Card } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useCustomerValue } from "providers/CustomerContext";
import { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { getInventorySKUList,getCustomerCode,getVendorCodeFromCustomer,getZone,getLocation,getOLN,getMLN,getCartonID,getDistinctSKUCode,getDistinctSKUCategory,
  getDistinctSKUGroup,
  getDistinctSKUSubgroup,getPhysicalCountList,generateReplenishment, retrievePhysicalCountList,retrievePhysicalCountException,retrieveReplenishmentList,retrieveReplenishmentListOnly} from "services/data.inventory.service";
import { LoadingDialog } from "ui-components/Alert";
import { ListLayout } from "ui-components/Layout";
import ServerTable from "ui-components/tables/ServerTable";
import BasicTabs from "ui-components/tabs/BasicTabs";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { createSO } from "services/data.outbound.service";
import { InboundLayout } from "ui-components/Layout";
import { InboundHeaderCard } from "ui-components/Layout";
import { FormTitle, DatePickerField, Text, SelectField } from "ui-components/Form";
import { Grid } from "@mui/material";
//import SO from "./components/SO";
//import { headerRender, headerValues, headerValidation } from "./physical-count-schema";
import { SelectFields } from "ui-components/Form";
import { Fieldset } from "ui-components/Form";
import switchButton from "assets/theme/components/form/switchButton";
import Switch from "@mui/material/Switch";
import { SwitchField } from "ui-components/Form";
import { TableCard } from "ui-components/Layout";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import BasicTable from "ui-components/tables/BasicTable";
import { CustomSwitch } from "ui-components/CustomInput";
import { Texts } from "ui-components/Form";
import { useRef } from "react";
import { CustomDatePicker } from "ui-components/CustomInput";
import { Success,Error_ } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";

const tabs = ["Stock Available", "Out Of Stock", "Inactive"];

function AddNewReplenishment({zoneLocationAisle}) {
  const {permissions, allowAll} = useTeamValue();
  const addPermission =
    allowAll ||
    (Boolean(permissions["Replenishment"]) &&
      permissions["Replenishment"].findIndex((b) => b === "add") !== -1);
  const { customerCode } = useCustomerValue();
  //const { threshold } = useState("");
  const [realReplNo, setRealReplNo] = useState(null);
  const { vendorCode } = useState("");
  //const [details, setDetails] = useState([]);
  const [alert, setAlert] = useState(null);
  const enabled = Boolean(customerCode);
  // const onError = (data) => {
  //   setAlert(<Error data={data} onChange={setAlert} />);
  // };
  const onError = (error) => {
    // console.log("error message"+error);
    // console.log(error.response.data.Message);
    // let errorMessage = "An unexpected error occurred.";
  
    // if (error.response && error.response.data && error.response.data.Message) {
    //   errorMessage = error.response.data.Message;
    // } else if (error.message) {
    //   errorMessage = error.message;
    // }
  
    setAlert(<Error_ data={error} onChange={setAlert} />);
  };
  const doRef = useRef("");
  // const today = dayjs(new Date()).format("YYYY-MM-DD");
  // const yesterday = dayjs().subtract(1, 'day').format("YYYY-MM-DD");
  const today = dayjs().format("YYYY-MM-DD");
  const yesterday = dayjs().subtract(1, 'day').format("YYYY-MM-DD");
  const [movementdate, setMovementDate] = useState(today);
  const [selectedOption, setSelectedOption] = useState("Today");
  // const handleDateChange = (newDate) => {
  //   const selectedDate = dayjs(newDate).format("YYYY-MM-DD");
  
  //   if (selectedDate === today || selectedDate === yesterday) {
  //     setMovementDate(selectedDate);
  //   } else {
  //     setAlert(<Error_ content="Please select only today or yesterday's date." onChange={setAlert} />);
  //     setMovementDate(today);
  //   }
  // };
  const handleDateChange = (event) => {
    const selectedValue = event.target.textContent;
    console.log(event);
    console.log(selectedValue);
    setSelectedOption(selectedValue); // Update the dropdown selection

    const newDate = selectedValue === "Today" ? today : yesterday;
    setMovementDate(newDate);
  };

  const handleThresholdChange = (e) => {
    const value = e.target.value;
  
    // Allow only positive integers (1 or greater)
    if (/^[0-9]\d*$/.test(value) && value >= 1 && value <= 100) {
      setThreshold(value);
    } else {
      setAlert(<Error_ content="Please enter a positive integer." onChange={setAlert} />);
      setThreshold(""); // Optionally, you can clear the invalid input
    }
  };
  //const { movementdate } = useState(date);
  // const { size, disabled, editable, ...data } = property;
  // const fieldProps = {
  //   ...data,
  //   control,
  //   errors,
  //   ...(disabled && { disabled }),
  //   ...(status !== "Open" && { type: "readonly" }),
  // };
  //added by leoliew
  // const [criteriaCustomerVendor, setCriteriaCustomerVendor] = useState("Customer");
  // const [criteriaZoneLocationAisle, setCriteriaZoneLocationAisle] = useState("Zone");
  // const [criteriaZoneLocationAisle2, setCriteriaZoneLocationAisle2] = useState([]);
  // const [criteriaSKUAttribute, setCriteriaSKUAttribute] = useState("");
  // const [criteriaSortOrder, setcriteriaSortOrder] = useState("Ascending");
  const [temp,setTemp]=useState({
    movement: true,
    entireWarehouse: false,
    skuOption:false})
  //const [pickers, setPickers] = useState([]);
  const [type, setType] = useState("EXCEPTION");
  const [list, setList] = useState([]);
  const [customers, setCustomers] = useState([]);
  //const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState([]);
  // const [locations, setLocations] = useState([]);
  // const [selectedLocation, setSelectedLocation] = useState([]);
  // const [zones, setZones] = useState([]);
  // const [selectedZone, setSelectedZone] = useState([]);
  // const [olns, setOLNs] = useState([]);
  // const [selectedOLN, setSelectedOLN] = useState([]);
  // const [mlns, setMLNs] = useState([]);
  // const [selectedMLN, setSelectedMLN] = useState([]);
  // const [cartonids, setCartonIDs] = useState([]);
  // const [selectedCartonID, setSelectedCartonID] = useState([]);
  const [skucodes, setSKUCodes] = useState([]);
  const [selectedSKUCodes, setSelectedSKUCodes] = useState([]);
  const [skucategories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [skugroups, setSKUGroups] = useState([]);
  const [selectedSKUGroup, setSelectedSKUGroup] = useState([]);
  const [skusubgroups, setSKUSubgroups] = useState([]);
  const [selectedSKUSubgroup, setSelectedSKUSubgroup] = useState([]);
  const [threshold, setThreshold] = useState("");

  if (zoneLocationAisle && zoneLocationAisle.length) {
    console.log(zoneLocationAisle.length);
  } else {
    console.log('Object is undefined or has no length property');
  }

  const columns = [
    {
      accessorKey: "replenishmentNo",
      header: "Replenishment No",
      width: 150,
    },
    {
      accessorKey: "lineNo",
      header: "Line No",
      width: 150,
    },
    {
      accessorKey: "customerCode",
      header: "Customer Code",
      width: 200,
      align: "right",
    },
    {
      accessorKey: "skuCode",
      header: "SKU Code",
      width: 150,
      align: "right",
    },
    {
      accessorKey: "quantity",
      header: "Replenish Qty",
      width: 150,
      align: "right",
    },
    {
      accessorKey: "fromWarehouse",
      header: "From Warehouse",
      width: 150,
    },
    {
      accessorKey: "fromZone",
      header: "From Zone",
      width: 150,
    },
    {
      accessorKey: "fromLocation",
      header: "From Location",
      width: 150,
    },
    {
      accessorKey: "fromCartonID",
      header: "From Carton ID",
      width: 150,
    },
    {
      accessorKey: "toWarehouse",
      header: "To Warehouse",
      width: 150,
    },
    {
      accessorKey: "toZone",
      header: "To Zone",
      width: 150,
    },
    {
      accessorKey: "toLocation",
      header: "To Location",
      width: 150,
    },
    {
      accessorKey: "toCartonID",
      header: "To Carton ID",
      width: 150,
    },
    // {
    //   accessorKey: "vendorCode",
    //   header: "Vendor Code",
    //   width: 150,
    // },
    
    // {
    //   accessorKey: "quantity",
    //   header: "Quantity",
    //   width: 150,
    //   align: "right",
    // },
  ];

  // const createSOMutation = useMutation(createSO, {
  //   onSuccess: (data) => {
  //     setAlert(<Success data={data} onChange={setAlert} />);
  //   },
  //   onError,
  // });

  const applyCriteriaSetting = (criteriaCustomerVendor,criteriaZoneLocationAisle2,criteriaSKUAttribute,criteriaSortOrder) => {
    resetVisibility();
    if (criteriaCustomerVendor !== null){
      console.log("criteriaCustomerVendor is not null");
      console.log(criteriaCustomerVendor);
      if (criteriaCustomerVendor.value == "1")
      {
        console.log("customer only");
        refetch();
        //show customer dropdownlist
        //populate customer dropdownlist data
      }
      else if (criteriaCustomerVendor.value == "2")
      {but 
        console.log("customer and vendor");
        setVendorVisible(true);
        refetch();
        refetchVendor();
        //show customer and vendor dropdownlist
        //populate customer and vendor dropdownlist data
      }
    };
    if (criteriaZoneLocationAisle2 !== null){
      console.log("criteriaZoneLocationAisle2 is not null");
      console.log(criteriaZoneLocationAisle2);
      if (criteriaZoneLocationAisle2.includes('Location'))
      {
        setLocationVisible(true);
        refetchLocation();
      }
      if (criteriaZoneLocationAisle2.includes('Zone'))
      {
        setZoneVisible(true);
        refetchZone();
      }
    };
    if (criteriaSKUAttribute !== null){
      console.log("criteriaSKUAttribute is not null");
      console.log(criteriaSKUAttribute);
      if (criteriaSKUAttribute.includes('OLN'))
      {
        setOLNVisible(true);
        console.log("i enter oln");
        refetchOLN();
      }
      else if (criteriaSKUAttribute.includes('MLN'))
      {
        setMLNVisible(true);
        console.log("i enter mln");
        refetchMLN();
      }
      else if (criteriaSKUAttribute.includes('Carton ID'))
      {
        setCartonIDVisible(true);
        console.log("i enter cartonid");
        refetchCartonID();
      }
      else if (criteriaSKUAttribute.includes('SKU Code'))
      {
        setSKUCodeVisible(true);
        console.log("i enter skucode");
        if (vendorCode === undefined) {
          refetchSKUCode(customerCode);
          console.log('1' );
        }
        else
        {
          refetchSKUCode(customerCode,selectedVendor);
          console.log('2' );
        }
        console.log(selectedVendor );
        
      }
      else if (criteriaSKUAttribute.includes('SKU Category'))
      {
        setSKUCategoryVisible(true);
        console.log("i enter cateogry");
        refetchCategory(customerCode);
      }
      else if (criteriaSKUAttribute.includes('SKU Group'))
      {
        setSKUGroupVisible(true);
        console.log("i enter skugroup");
        refetchSKUGroup(customerCode);
      }
      else if (criteriaSKUAttribute.includes('SKU Subgroup'))
      {
        setSKUSubgroupVisible(true);
        console.log("i enter skusubgroup");
        refetchSKUSubgroup(customerCode);
      }
    };
    if (criteriaSortOrder !== null){
      console.log("criteriaSortOrder is not null");
    };
  };

  const { isFetching, refetch } = useQuery({
    queryKey: [ "customerOption",{ customerCode } ],
    queryFn: () =>
    getCustomerCode(),
    //getVendorCodeFromCustomer(customerCode),
    enabled: Boolean(customerCode),
    onSuccess: (data) => setCustomers(data.data.data),
    //onSuccess: (data) => setVendors(data.data.data),
    onError,
  });

  const { isFetchingExceptionList,refetch:refetchExceptionList } = useQuery({
    //queryKey: ["exceptionlist"],
    queryFn: () => {
      console.log("realReplNo in queryFn:", realReplNo); // Log realReplNo in queryFn
      return retrieveReplenishmentList(realReplNo);
    },
    //queryFn: () => retrieveReplenishmentList(realReplNo),
    enabled: false,
    onSuccess: (data) => 
      {
        console.log(data);
        setList(data.data.data)
      },
  });

  // const { isFetchingExceptionList2,refetch:refetchExceptionList2 } = useMutation({
  //   queryKey: ["exceptionlist"],
  //   queryFn: () => getPhysicalCountList2({ 
  //     customerCode,
  //     vendorCode:selectedVendor,
  //     locationID:selectedLocation,
  //     zoneID:selectedZone,
  //     skuCode:selectedSKUCodes,
  //     category:selectedCategory,
  //     skuGroup:selectedSKUGroup,
  //     skuSubgroup:selectedSKUSubgroup,
  //     oln:selectedOLN,
  //     mln:selectedMLN,
  //     cartonID:selectedCartonID,
  //     freeze:temp.freeze,
  //     showSystemQuantity:temp.showSystemQuantity,
  //     hold:temp.excludeQuarantineItem,
  //     sortorder:criteriaSortOrder
  //    }),
  //   enabled: false,
  //   onSuccess: (data) => {
  //     console.log(data);
  //     const { pCountNo } = data.data; // Assuming the pCountNo is returned in the data object
  //     console.log("PCountNo:", pCountNo);
  //   retrievePhysicalCountList(pCountNo);
  //   //setList(data.data.data);
  // },
  // });

  const handleDownload = () => {
      retrieveReplenishmentListOnly(realReplNo).then((response) => {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      //link.setAttribute("download", `PhysicalCountException.xlsx`);
      link.setAttribute("download", `${realReplNo}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  // const getreplenishmentMutation = useMutation((requestdata) => generateReplenishment(requestdata), {
  //   onSuccess: (data) => {
  //     console.log(data);
  //     if (data && data.data && data.data.pCountNo) {
  //     const { pCountNo } = data.data;
  //     console.log("PCountNo:", pCountNo);
  //     retrievePhysicalCountList(pCountNo).then((response)=> {
  //       const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", `${pCountNo}.xlsx`);
  //     document.body.appendChild(link);
  //     link.click();
  //     });
  //   }
  //   else
  //   {
  //     refetchExceptionList();
  //   }
  //     // queryClient.invalidateQueries(["exception-list"]);
  //     // setAlert(<Success data={data} onChange={setAlert} />);
  //   },
  //   onError,
  // });

  const getreplenishmentMutation = useMutation(
    (requestData) => generateReplenishment(requestData),
    {
      onSuccess: (data) => {
        const { replNo,realreplno } = data.data;
        //const { realreplNo } = data.data.realreplno;
        console.log("Replno:", replNo);
        console.log("realreplno:", realreplno);
        console.log(data);
        setRealReplNo(realreplno);
        setAlert(<Success data={data} onChange={setAlert} />);
        
        //refetchExceptionList(realReplNo);
      },
      onError, // Use the onError function to handle errors
    }
  );

  useEffect(() => {
    if (realReplNo) {
      console.log("realReplNo:", realReplNo);
      // Perform an action with the updated realReplNo
      refetchExceptionList(realReplNo);
    }
  }, [realReplNo]);

  const ongetreplenishmentMutation = () => {
    // resetVisibility();
    setList([]);
    console.log("inside on getreplenishmentmutation:");
    getreplenishmentMutation.mutate({ 
      customerCode,
      //vendorCode:selectedVendor,
      //locationID:selectedLocation,
      //zoneID:selectedZone,
      skuCode:selectedSKUCodes,
      category:selectedCategory,
      skuGroup:selectedSKUGroup,
      skuSubgroup:selectedSKUSubgroup,
      // oln:selectedOLN,
      // mln:selectedMLN,
      // cartonID:selectedCartonID,
      movement:temp.movement,
      entireWarehouse:temp.entireWarehouse,
      skuOption:temp.skuOption,
      threshold:threshold,
      movementdate:movementdate
     });
  }

  const { isFetchingVendor, refetch:refetchVendor } = useQuery({
    queryKey: [ "vendorOption", { customerCode } ],
    queryFn: () =>
    getVendorCodeFromCustomer({
      customerCode
    }),
    enabled: false,
    onSuccess: (data) => setVendors(data.data.data),
    onError,
  });

  const { isFetchingLocation, refetch:refetchLocation } = useQuery({
    queryKey: [ "locationOption", { customerCode } ],
    queryFn: () =>
    getLocation(true),
    enabled: false,
    onSuccess: (data) => setLocations(data.data.data.map(x=>x.locationID)),
    onError,
  });

  const { isFetchingZone, refetch:refetchZone } = useQuery({
    queryKey: [ "zoneOption", { customerCode } ],
    queryFn: () =>
    getZone(true),
    enabled: false,
    onSuccess: (data) => setZones(data.data.data.map(x=>x.zoneID)),
    onError,
  });

  const { isFetchingOLN, refetch:refetchOLN } = useQuery({
    queryKey: [ "olnOption", { customerCode } ],
    queryFn: () =>
    getOLN(),
    enabled: false,
    onSuccess: (data) => setOLNs(data.data.data),
    onError,
  });

  const { isFetchingMLN, refetch:refetchMLN } = useQuery({
    queryKey: [ "MLNOption", { customerCode } ],
    queryFn: () =>
    getMLN(),
    enabled: false,
    onSuccess: (data) => setMLNs(data.data.data),
    onError,
  });

  const { isFetchingCartonID, refetch:refetchCartonID } = useQuery({
    queryKey: [ "CartonIDOption", { customerCode } ],
    queryFn: () =>
    getCartonID(),
    enabled: false,
    onSuccess: (data) => setCartonIDs(data.data.data),
    onError,
  });

  const { isFetchingSKUCode, refetch:refetchSKUCode } = useQuery({
    queryKey: [ "SKUCodeOption", { customerCode } , {selectedVendor} ],
    queryFn: () =>
    getDistinctSKUCode({
      customerCode,
      selectedVendor
    }),
    enabled: enabled,
    onSuccess: (data) => setSKUCodes(data.data.data),
    onError,
  });

  const { isFetchingCategory, refetch:refetchCategory } = useQuery({
    queryKey: [ "SKUCategoryOption", { customerCode }, {selectedVendor} ],
    queryFn: () =>
    getDistinctSKUCategory({
      customerCode,
      selectedVendor
    }),
    enabled: enabled,
    onSuccess: (data) => setCategories(data.data.data),
    onError,
  });

  const { isFetchingSKUGroup, refetch:refetchSKUGroup } = useQuery({
    queryKey: [ "SKUGroupOption", { customerCode }, {selectedVendor} ],
    queryFn: () =>
    getDistinctSKUGroup({
      customerCode,
      selectedVendor
    }),
    enabled: enabled,
    onSuccess: (data) => setSKUGroups(data.data.data),
    onError,
  });

  const { isFetchingSKUSubGroup, refetch:refetchSKUSubgroup } = useQuery({
    queryKey: [ "SKUSubgroupOption", { customerCode }, {selectedVendor} ],
    queryFn: () =>
    getDistinctSKUSubgroup({
      customerCode,
      selectedVendor
    }),
    enabled: enabled,
    onSuccess: (data) => setSKUSubgroups(data.data.data),
    onError,
  });

  // const onExport = () => {
  //   //setLoading(<LoadingDialog />);
  //   exportMutation.mutate(
  //     { customerCode, exceptionalType: type },
  //     {
  //       onSuccess: (data) => {
  //         const blob = new Blob([data.data]);
  //         const url = window.URL.createObjectURL(blob);
  //         const link = document.createElement("a");
  //         link.href = url;
  //         link.setAttribute("download", `${customerCode}_${type}.xlsx`);
  //         document.body.appendChild(link);
  //         link.click();
  //       },
  //     }
  //   );
  // };
  // const exportStatus = exportMutation.status === "loading";

  // const [isVendorVisible, setVendorVisible] = useState(false);
  // const [isZoneVisible, setZoneVisible] = useState(false);
  // const [isLocationVisible, setLocationVisible] = useState(false);
  const [isSKUCodeVisible, setSKUCodeVisible] = useState(true);
  const [isSKUCategoryVisible, setSKUCategoryVisible] = useState(true);
  const [isSKUGroupVisible, setSKUGroupVisible] = useState(true);
  const [isSKUSubgroupVisible, setSKUSubgroupVisible] = useState(true);
  // const [isOLNVisible, setOLNVisible] = useState(false);
  // const [isMLNVisible, setMLNVisible] = useState(false);
  // const [isCartonIDVisible, setCartonIDVisible] = useState(false);

  const resetVisibility = () => {
    // setVendorVisible(false);
    // setZoneVisible(false);
    // setLocationVisible(false);
    setSKUCodeVisible(false);
    setSKUCategoryVisible(false);
    setSKUGroupVisible(false);
    setSKUSubgroupVisible(false);
    // setOLNVisible(false);
    // setMLNVisible(false);
    // setCartonIDVisible(false);
  };

  useEffect(() => {
    console.log("Selected Vendor:", selectedVendor);
    if (selectedVendor !== "") {
      refetchSKUCode();
      refetchCategory();
      refetchSKUGroup();
      refetchSKUSubgroup();
    }
  }, [selectedVendor]);

  return (
    <>
    {isFetching && isFetchingVendor && isFetchingLocation && isFetchingZone && isFetchingOLN && isFetchingMLN && isFetchingCartonID && isFetchingSKUCode && isFetchingCategory && isFetchingSKUGroup && isFetchingSKUSubGroup && <LoadingDialog />}
    <InboundLayout lg={12}>
      {alert}
      {/* codebelowforseethedatainswitch */}
      {/* {JSON.stringify(temp)}
      {JSON.stringify(criteriaCustomerVendor)}
      {JSON.stringify(criteriaZoneLocationAisle)}
      {JSON.stringify(criteriaSKUAttribute)}
      {JSON.stringify(criteriaSortOrder)}
      {JSON.stringify(criteriaZoneLocationAisle2)} */}
      <InboundHeaderCard>
        <FormTitle title={"Replenishment"} />
        <form noValidate>
          {/* <switchButton>123</switchButton> */}
          {/* <Grid container spacing={3}>
          <Grid item xs={4}>
          <CustomSwitch
            field={{ name: "freeze", label: "Freeze", checked: temp.freeze }}
            onChange={() => setTemp({...temp,freeze:!temp.freeze})}
          />
          </Grid>
          <Grid item xs={4}>
          <CustomSwitch
            field={{ name: "Show System Quantity", label: "Show System Quantity", checked: temp.showSystemQuantity }}
            onChange={() => setTemp({...temp,showSystemQuantity:!temp.showSystemQuantity})}
          />
          </Grid>
          <Grid item xs={4}>
          <CustomSwitch
            field={{ name: "Exclude Quarantine Item", label: "Exclude Quarantine Item", checked: temp.excludeQuarantineItem }}
            onChange={() => setTemp({...temp,excludeQuarantineItem:!temp.excludeQuarantineItem})}
          />
          </Grid>
          </Grid> */}
          {/* <SwitchField/> */}
          {/* <SwitchField field={{ 'abc': 'def' }} /> */}
          <Fieldset label="Replenish by" sx={{ marginBottom: "1.5rem" }}>
            <Grid container spacing={3}>
            <Grid item xs={4}>
          <CustomSwitch
            field={{ name: "Movement Of The Day", label: "Movement Of The Day", checked: temp.movement }}
            onChange={() =>
              setTemp({
                movement: true,
                entireWarehouse: false,
                skuOption: false,
              })
            }
          />
          </Grid>
          <Grid item xs={4}>
          <CustomSwitch
            field={{ name: "Entire Warehouse", label: "Entire Warehouse", checked: temp.entireWarehouse }}
            onChange={() =>
              setTemp({
                movement: false,
                entireWarehouse: true,
                skuOption: false,
              })
            }
          />
          </Grid>
          <Grid item xs={4}>
          <CustomSwitch
            field={{ name: "SKU Option", label: "SKU Option", checked: temp.skuOption }}
            onChange={() =>
              setTemp({
                movement: false,
                entireWarehouse: false,
                skuOption: true,
              })
            }
          />
          </Grid>
          
              {/* <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "Option",
                    value: criteriaCustomerVendor,
                    errors: {},
                  }}
                  options={[
                    { label: "Movement Of The Day", value: "1" },
                    { label: "SKU Option", value: "2" },
                    { label: "Entire Warehouse", value: "3" }
                  ]}
                  onChange={(e, v) => setCriteriaCustomerVendor(v)}
                />
              </Grid> */}
              {/* <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "Zone/Location/Aisle",
                    value: criteriaZoneLocationAisle,
                    errors: {},
                  }}
                  options={["Zone", "Location", "Aisle"]}
                  onChange={(e, v) => setCriteriaZoneLocationAisle(v)}
                />
              </Grid> */}
              {/* <Grid item xs={3}>
            <SelectFields
              field={{ name: "", label: "Zone/Location", value: criteriaZoneLocationAisle2, errors: {}, multiple: true }}
              options={["Zone", "Location"]}
              onChange={(e, v) => setCriteriaZoneLocationAisle2(v)}
            />
          </Grid> */}
           {isSKUCodeVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "SKU Code",
                    value: selectedSKUCodes,
                    errors: {},
                    multiple: true,
                    disabled: !temp.skuOption
                  }}
                  options={skucodes}
                  onChange={(e, v) => setSelectedSKUCodes(v)}
                />
              </Grid>
              )}
              {isSKUCategoryVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "SKU Category",
                    value: selectedCategory,
                    errors: {},
                    multiple: true,
                    disabled:!temp.skuOption
                  }}
                  options={skucategories}
                  onChange={(e, v) => setSelectedCategory(v)}
                />
              </Grid>
              )}
              {isSKUGroupVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "SKU Group",
                    value: selectedSKUGroup,
                    errors: {},
                    multiple: true,
                    disabled:!temp.skuOption
                  }}
                  options={skugroups}
                  onChange={(e, v) => setSelectedSKUGroup(v)}
                />
              </Grid>
              )}
              {isSKUSubgroupVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "SKU SubGroup",
                    value: selectedSKUSubgroup,
                    errors: {},
                    multiple: true,
                    disabled:!temp.skuOption
                  }}
                  options={skusubgroups}
                  onChange={(e, v) => setSelectedSKUSubgroup(v)}
                />
              </Grid>
              )}
              {/* <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "SKUAttributes",
                    value: criteriaSKUAttribute,
                    errors: {},
                  }}
                  options={[
                    "SKU Code",                  
                    "SKU Category",
                    "SKU Group",
                    "SKU Subgroup",
                  ]}
                  onChange={(e, v) => setCriteriaSKUAttribute(v)}
                  disabled
                />
              </Grid> */}
              {/* <Grid item xs={3}>
                <SelectFields
                  field={{ name: "", label: "Sort Order", value: criteriaSortOrder, errors: {} }}
                  options={["Ascending", "Descending"]}
                  onChange={(e, v) => setcriteriaSortOrder(v)}
                />
              </Grid> */}
            </Grid>
          </Fieldset>
          {/* <Grid container spacing={12}>
            <Grid item xs={3}>
              <MDButton color="info" variant="gradient" onClick={() => applyCriteriaSetting(criteriaCustomerVendor, criteriaZoneLocationAisle2, criteriaSKUAttribute, criteriaSortOrder)}>
              Apply Criteria Setting
              </MDButton>
            </Grid>
          </Grid> */}
          <br></br>
          <Fieldset label="Criteria" sx={{ marginBottom: "1.5rem" }}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
              {/* <Text
              field={{
                label: "Threshold",
                name: "threshold",
                value: threshold,
              }}
            /> */}
            {/* <Text field={fieldProps} /> */}
            <Texts
            field={{ name: "threshold", label: "Threshold (0-100%)", ref: doRef, maxLength: 20 }}
            // onChange={({ target }) => (doRef.current = target.value)}
            //onChange={(e, v) => setThreshold(v)}
            onChange={handleThresholdChange}
            value={threshold}
          />
            
                 {/* <SelectFields
                  field={{ name: "", label: "Customer2", value: "", errors: {} }}
                  options={customers}
                  onChange={(e, v) => populatedCustomerVendor(v)}
                  disabled
                /> */}
              </Grid>
              <Grid item xs={4}>
              {/* <CustomDatePicker
                field={{
                  name: "date",
                  label: "Movement Date",
                  value: movementdate,
                  onChange: handleDateChange,
                  disableClearable: true,
                  disabled: !temp.movement
                }}
              /> */}
              {/* <InputLabel id="date-select-label">Movement Date</InputLabel> */}
              <SelectFields
                  field={{ name: "movementDate", label: "Movement Date", value: selectedOption , errors: {},
                  disabled: !temp.movement}}
                  options={[
                    { label: "Today", value: "Today" },
                    { label: "Yesterday", value: "Yesterday" }
                  ]}
                  onChange={handleDateChange}
                />
                {/* <p>Selected Date: {movementdate}</p>
                <p>Selected value: {selectedOption}</p> */}
                
      {/* <SelectFields
        labelId="date-select-label"
        value={movementdate}
        onChange={handleDateChange}
        disabled={!temp.movement}
      > */}
        {/* <MenuItem value={todayStr}>Today ({todayStr})</MenuItem>
        <MenuItem value={yesterdayStr}>Yesterday ({yesterdayStr})</MenuItem> */}
      {/* </SelectFields> */}
            </Grid>
              {/* {isVendorVisible && (
              <Grid item xs={4}>
                <SelectFields
                  field={{
                    name: "",
                    label: "Vendor",
                    value: selectedVendor,
                    errors: {},
                    multiple: true
                  }}
                  options={vendors}
                  onChange={(e, v) => setSelectedVendor(v)}
                />
              </Grid>
              )}
              {isZoneVisible && (
              <Grid item xs={4}>
                <SelectFields
                  field={{ name: "", label: "Zone", value: selectedZone, errors: {},multiple: true }}
                  options={zones}
                  onChange={(e, v) => setSelectedZone(v)}
                />
              </Grid>
              )}
              {isLocationVisible && (
              <Grid item xs={4}>
                <SelectFields
                  field={{
                    name: "",
                    label: "Location",
                    value: selectedLocation ?? null,
                    errors: {},
                    multiple: true
                  }}
                  options={locations}
                  onChange={(e, v) => setSelectedLocation(v)}
                />
              </Grid>
              )} */}
              {/* <Grid item xs={4}>
                <SelectFields
                  field={{ name: "", label: "Aisle", value: "", errors: {} }}
                  options={["Aisle"]}
                  onChange={(e, v) => setCriteriaZoneLocationAisle(v)}
                />
              </Grid> */}
              {/* {isOLNVisible && (
              <Grid item xs={4}>
                <SelectFields
                  field={{
                    name: "",
                    label: "OLN",
                    value: selectedOLN,
                    errors: {},
                    multiple: true
                  }}
                  options={olns}
                  onChange={(e, v) => setSelectedOLN(v)}
                />
              </Grid>
              )}
              {isMLNVisible && (
              <Grid item xs={4}>
                <SelectFields
                  field={{
                    name: "",
                    label: "MLN",
                    value: selectedMLN,
                    errors: {},
                    multiple: true
                  }}
                  options={mlns}
                  onChange={(e, v) => setSelectedMLN(v)}
                />
              </Grid>
              )}
              {isCartonIDVisible && (
              <Grid item xs={4}>
                <SelectFields
                  field={{
                    name: "",
                    label: "CartonID",
                    value: selectedCartonID,
                    errors: {},
                    multiple: true
                  }}
                  options={cartonids}
                  onChange={(e, v) => setSelectedCartonID(v)}
                />
              </Grid>
              )} */}
             
            </Grid>
          </Fieldset>
          <Grid container spacing={12}>
            <Grid item xs={3}>
              <MDButton color="info" variant="gradient" disabled={!addPermission} onClick={() => ongetreplenishmentMutation()}>
                Replenish
              </MDButton>
            </Grid>
            {/* <Grid item xs={3}>
              <MDButton color="info" variant="gradient" onClick={refetchExceptionList}>
                manual generate exception
              </MDButton>
            </Grid> */}
          </Grid>
          <br></br>
          <FormTitle title={"Replenishment Details"} />
          <TableCard sx={{ marginTop: 4 }}>
            <Grid sx={{ padding: "10px" }} container spacing={3}>
              <Grid item>
                <MDButton
                  color="info"
                  variant="gradient"
                  onClick={handleDownload}
                  disabled={customerCode === null}
                >
                  Export
                </MDButton>
              </Grid>
              <Grid item>
                <FormControl>
                  {/* <FormLabel>type</FormLabel> */}
                  <RadioGroup
                    row
                    onChange={(e) => {
                      setType(e.target.value);
                    }}
                  >
                    {/* <FormControlLabel
                  labelPlacement="left"
                  value="EXCEPTION"
                  label="Preallocate Exception"
                  control={<Radio checked={type === "EXCEPTION"} />}
                />
                <FormControlLabel
                  labelPlacement="left"
                  value="FAILED"
                  label="Allocation Failed"
                  control={<Radio checked={type === "FAILED"} />}
                /> */}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
            <BasicTable data={list} columns={columns} />
            </TableCard>
            <br></br>
            <Grid container spacing={12}>
            <Grid item xs={3}>
              {/* <MDButton color="info" variant="gradient" onClick={() => ongetphysicalcountMutation()}>
              Confirm Replenishment 
              </MDButton> */}
            </Grid>
            <Grid item xs={3}>
              {/* <MDButton color="info" variant="gradient" onClick={() => ongetphysicalcountMutation()}>
                Cancel Replenishment
              </MDButton> */}
            </Grid>
            {/* <Grid item xs={3}>
              <MDButton color="info" variant="gradient" onClick={refetchExceptionList}>
                manual generate exception
              </MDButton>
            </Grid> */}
          </Grid>
         
        </form>
      </InboundHeaderCard>

      {/* <Detail {...detailProps} /> */}
      {/* <InboundSubmitButton label="Submit" onClick={onSubmit} disabled={isSubmitting} /> */}
    </InboundLayout>
    </>
  );
}

export default AddNewReplenishment;
